<!-- Start New Trial -->
<p-dialog [(visible)]="visible" [resizable]="false" appendTo="body" [modal]="true"
[breakpoints]="{'767px': '100vw'}" [style]="{width: '400px'}" styleClass="no-header-modal overflow-visible"
[attr.aria-label]="'create-client-trial-dialog'"
[attr.data-testid]="'create-client-trial-dialog'">

<ng-template pTemplate="header" styleClass="hidden"></ng-template>
<ng-template pTemplate="content" styleClass="p-0">

  <!-- Header -->
  <div class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300">
    <h2 class="mb-0 text-sm" [attr.data-testid]="'dialog-title'"><i class="fa fa-plus mr-3 text-500" [attr.data-testid]="'plus-icon'"></i>{{'CLIENT_TRIAL.START_NEW_TRIAL' | translate}}
    </h2>
    <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopup(false)"
      [attr.aria-label]="'close-dialog-button'"
      [attr.data-testid]="'close-dialog-button'"></div>
  </div>
  <!-- Header -->
  <form [formGroup]="clientTrialForm" (ngSubmit)="saveTrialForm()" [attr.data-testid]="'client-trial-form'">
  <!-- Content -->
  <div class="surface-100 p-4 text-sm" [attr.data-testid]="'form-content'">
  
    <div class="mb-4 flex" [attr.data-testid]="'date-section'">
      <div class="w-6 pr-3" [attr.data-testid]="'start-date-section'">
        <label class="font-medium text-700 text-xs mb-2 block uppercase" [attr.aria-label]="'trial-date-label'">{{'CLIENT_TRIAL.TRIAL_DATE' | translate}}</label>
        <p-datepicker [showIcon]="true" formControlName="startDate" styleClass="w-full" [placeholder]="'common.PLACEHOLDER.SELECT_DATE' | translate" inputStyleClass="text-sm" 
         [minDate]="minimumDate" (onSelect)="getEndDate($event)"
         [attr.aria-label]="'trial-date-calendar'"
         [attr.data-testid]="'trial-date-calendar'"> 
        </p-datepicker>
        <app-error-msg *ngIf="StartDateFormControl?.touched && StartDateFormControl?.invalid"
          [errors]="StartDateFormControl?.errors"
          [fieldLabel]="'CLIENT_TRIAL.ERROR_TRIAL_DATE' | translate"
          [attr.data-testid]="'trial-date-error'">
        </app-error-msg>
      </div>
      <div class="w-6 pl-3" [attr.data-testid]="'end-date-section'">
        <label class="font-medium text-700 text-xs mb-2 block uppercase" [attr.aria-label]="'trial-end-date-label'">{{'CLIENT_TRIAL.TRIAL_END_DATE' | translate}}</label>
        <strong class="block mt-3" *ngIf="trialMaster" [attr.data-testid]="'trial-end-date'">{{ trialEndDate | date : 'd MMM yy'}}</strong>
      </div>
    </div>

    <!-- <div class="mb-4">
      <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CLIENT_TRIAL.PREFRED_TIME' | translate}}</label>
      <p-datepicker [showIcon]="true" icon="fa fa-clock" hourFormat="12" [timeOnly]="true" inputId="timeonly"
        [showIcon]="true" [placeholder]="'common.PLACEHOLDER.SELECT_TIME' | translate"  formControlName="startTime" styleClass="text-sm w-full" inputStyleClass="text-sm w-full" >
      </p-datepicker>
      <app-error-msg *ngIf="StartTimeFormControl.touched && StartTimeFormControl.invalid"
      [errors]="StartTimeFormControl.errors"
      [fieldLabel]="'CLIENT_TRIAL.ERROR_TIME' | translate">
    </app-error-msg>
    </div> -->

    <div class="" [attr.data-testid]="'trial-owner-section'">
      <label class="font-medium text-700 text-xs mb-2 block uppercase" [attr.aria-label]="'trial-owner-label'">{{'CLIENT_TRIAL.TRIAL_OWNER' | translate}}</label>
      <staff-selector [formGroup]="clientTrialForm" [controlName]="trialOwnerFormControl"
       [styleClass]="'w-full text-sm'"
       [placeHolder]="'SCHEDULE.CREATEAPPOINTMENT.SELECT' | translate"
       [attr.data-testid]="'trial-owner-selector'">
      </staff-selector>
      <app-error-msg *ngIf="trialOwnerFormControl?.touched && trialOwnerFormControl?.invalid"
          [errors]="trialOwnerFormControl?.errors"
          [fieldLabel]="'CLIENT_TRIAL.TRIAL_OWNER' | translate"
          [attr.data-testid]="'trial-owner-error'">
        </app-error-msg>  
    </div>

    <!-- Keyfob Section -->
    <div class="mt-4" *ngIf="keyFobRequired" [attr.data-testid]="'keyfob-section'">
      <label class="font-medium text-700 text-xs mb-2 block uppercase" [attr.aria-label]="'keyfob-label'">{{'POS.MEMBERSHIP_ADDON.KEY_FOB_NUMBER' | translate}}</label>
      
      <!-- Button Selection -->
      <div class="p-buttonset white-space-nowrap mb-2" *ngIf="showDigitalKeyFob">
        <button pButton pRipple type="button" 
          [ngClass]="digitalKeyFOBSelected ? 'bg-primary' : 'surface-600'" 
          (click)="toggleKeyFobSelectionType(true,false)" 
          class="border-right-1 border-white text-sm" 
          [label]="'POS.MEMBERSHIP_ADDON.DIGITAL_BTN' | translate"
          [attr.aria-label]="'select-digital-key-fob-button'" 
          [attr.data-testid]="'select-digital-key-fob-button'">
        </button>
        <button pButton pRipple type="button" 
          [ngClass]="physicalKeyFOBSelected ? 'bg-primary' : 'surface-600'" 
          (click)="toggleKeyFobSelectionType(false,true)" 
          class="border-right-1 border-white text-sm" 
          [label]="'POS.MEMBERSHIP_ADDON.PHYSICAL_BTN' | translate"
          [attr.aria-label]="'select-physical-key-fob-button'" 
          [attr.data-testid]="'select-physical-key-fob-button'">
        </button>
      </div>
      
      <!-- Input Field -->
      <div *ngIf="physicalKeyFOBSelected">
        <input type="text" 
          class="w-full text-sm" 
          formControlName="keyfob" 
          pInputText 
          placeholder="Enter keyfob number"
          [attr.aria-label]="'enter-key-fob-number-input'" 
          [attr.data-testid]="'enter-key-fob-number-input'"/>
      </div>
      
      <!-- Keyfob validation feedback -->
      <div *ngIf="isValidatingKeyfob && physicalKeyFOBSelected" 
        class="flex align-items-center mt-2 text-sm text-600"
        [attr.data-testid]="'keyfob-validating-message'">
        <i class="pi pi-spin pi-spinner mr-2"></i>
        <span>Validating keyfob...</span>
      </div>
      
      <div *ngIf="!isValidatingKeyfob && keyfobValidationMessage && keyFobFormControl?.value && keyFobFormControl?.value !== clientKeyfob && physicalKeyFOBSelected" 
        [ngClass]="{'text-green-600': isKeyfobValid, 'text-red-600': !isKeyfobValid}" 
        class="flex align-items-center mt-2 text-sm"
        [attr.data-testid]="'keyfob-validation-message'">
        <i [ngClass]="{'pi pi-check-circle': isKeyfobValid, 'pi pi-times-circle': !isKeyfobValid}" class="mr-2"></i>
        <span>{{keyfobValidationMessage}}</span>
      </div>
      
      <app-error-msg *ngIf="keyFobFormControl?.invalid && keyFobFormControl?.dirty && !digitalKeyFOBSelected" 
        [errors]="keyFobFormControl?.errors" 
        [fieldLabel]="'POS.MEMBERSHIP_ADDON.KEY_FOB_NUMBER' | translate"
        [attr.data-testid]="'keyfob-error-message'">
      </app-error-msg>
    </div>

  </div>
  <!-- Content -->

  <!-- Footer -->
  <div class="p-3 flex justify-content-between align-items-center border-top-1 border-300" [attr.data-testid]="'dialog-footer'">
    <button pButton pRipple type="button" [label]="'CLIENT_TRIAL.CANCEL'| translate" class="p-button-text text-sm" (click)="closePopup(false)"
      [attr.aria-label]="'cancel-create-trial-button'"
      [attr.data-testid]="'cancel-create-trial-button'">
    </button>
    <button pButton pRipple type="submit" [loading]="isFormSubmitting" [label]="'CLIENT_TRIAL.START_TRIAL'| translate" class="text-sm"
      [attr.aria-label]="'start-create-trial-button'"
      [attr.data-testid]="'start-create-trial-button'">
   </button>
  </div>
  <!-- Footer -->
 </form>
</ng-template>

</p-dialog>
<!-- Start New Trial -->